import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef } from "react"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
} from "reactstrap"

import TableActiveComponent from './Components/TablePrimaryComponent'

const IndexView = (props) => {

    const activeRef = useRef();
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()
    

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">

                        <Card>
                            <CardBody>
                                <div className="float-end">
                                {
                                    (accessRole('create')) ?
                                        <Link to="?create">
                                            <Button color="primary">Tambah Daftar Status Pegawai</Button>
                                        </Link>
                                    : null
                                }
                                </div>
                                <CardTitle>Daftar Status Pegawai</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Kelola Daftar Status Pegawai
                                </CardSubtitle>
                                <hr />
                                <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef}/>
                            </CardBody>
                        </Card>
                        
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView